import React, { useState } from 'react';
import axiosInstance from '../../axiosConfig';
import './Master.css'; // Updated import

const ForumEditDeleteControls = ({
  messageId,
  isReply,
  originalTitle,
  originalContent,
  onEdit,
  onDelete,
  isOwner,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editContent, setEditContent] = useState(originalContent);
  const [editTitle, setEditTitle] = useState(originalTitle || '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleEdit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const endpoint = isReply
      ? `/messageboard/forums/reply/${messageId}/edit/`
      : `/messageboard/forums/post/${messageId}/edit/`;

    const payload = { content: editContent };
    if (!isReply) payload.title = editTitle;

    try {
      const response = await axiosInstance.put(endpoint, payload);
      onEdit(messageId, response.data.title || null, response.data.content);
      setIsEditing(false);
    } catch (error) {
      console.error('Error editing:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this?')) {
      const endpoint = isReply
        ? `/messageboard/forums/reply/${messageId}/delete/`
        : `/messageboard/forums/post/${messageId}/delete/`;

      try {
        await axiosInstance.delete(endpoint);
        onDelete(messageId);
      } catch (error) {
        console.error('Error deleting:', error);
      }
    }
  };

  if (!isOwner) return null;

  return (
    <div className="edit-delete-controls">
      {isEditing ? (
        <form onSubmit={handleEdit} className="nested-reply-form">
          {!isReply && (
            <input
              type="text"
              value={editTitle}
              onChange={(e) => setEditTitle(e.target.value)}
              placeholder="Edit title"
              style={{ marginBottom: '12px' }}
              required
            />
          )}
          <textarea
            value={editContent}
            onChange={(e) => setEditContent(e.target.value)}
            placeholder="Edit content"
            className="nested-reply-textarea"
            required
          />
          <div className="nested-reply-actions">
            <button type="button" onClick={() => setIsEditing(false)} className="cancel-reply-btn">
              Cancel
            </button>
            <button type="submit" disabled={isSubmitting} className="submit-reply-btn">
              {isSubmitting ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      ) : (
        <>
          <button onClick={() => setIsEditing(true)}>Edit</button>
          <button onClick={handleDelete}>Delete</button>
        </>
      )}
    </div>
  );
};

export default ForumEditDeleteControls;